import { render, staticRenderFns } from "./positioning-device-type.vue?vue&type=template&id=578e1c75&scoped=true"
import script from "./positioning-device-type.vue?vue&type=script&lang=js"
export * from "./positioning-device-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e1c75",
  null
  
)

export default component.exports